<template>
  <div>
    <v-container>
      <v-layout>
        <v-flex>
          <v-dialog
            ref="datedialog"
            v-model="datemodal"
            :return-value.sync="date"
            persistent
            lazy
            full-width
            width="290px"
            @input="changeDate"
          >
            <template v-slot:activator="{ on }">
              <div class="form-control">
                <input
                  type="text"
                  v-model="date"
                  label="Picker in dialog"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                  style="display: inline-block; width: auto"
                />
              </div>
            </template>
            <v-date-picker v-model="date" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="datemodal = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.datedialog.save(date)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex shrink>
          <v-btn @click="exportAll" :loading="loadingExport" color="primary" depressed>
            ส่งออกทั้งหมด
          </v-btn>
        </v-flex>
      </v-layout>

      <NvbbSummaryDrinkDetail :date="shippingDate" v-model="data.all" :loading="loading">
        <span slot="header"
          >สรุปยอดผลิต ของวันที่ {{ produceDate | dateFormat('DD/MM/YYYY') }}</span
        >
      </NvbbSummaryDrinkDetail>

      <NvbbSummaryDrinkDetail :date="shippingDate" v-model="data.all" :loading="loading">
        <span slot="header"
          >สรุปยอดจัดส่ง ของวันที่ {{ shippingDate | dateFormat('DD/MM/YYYY') }}</span
        >
      </NvbbSummaryDrinkDetail>
    </v-container>

    <v-divider class="my-3" />

    <v-container>
      <NvbbSummaryDrinkPhytoSmoozDetail
        :date="shippingDate"
        v-model="data.smooz"
        :loading="loading"
      >
        <span slot="header"
          >สรุปยอดผลิต ของวันที่ {{ produceDate | dateFormat('DD/MM/YYYY') }}</span
        >
      </NvbbSummaryDrinkPhytoSmoozDetail>

      <NvbbSummaryDrinkPhytoSmoozDetail
        :date="shippingDate"
        v-model="data.smooz"
        :loading="loading"
      >
        <span slot="header"
          >สรุปยอดจัดส่ง ของวันที่ {{ shippingDate | dateFormat('DD/MM/YYYY') }}</span
        >
      </NvbbSummaryDrinkPhytoSmoozDetail>
    </v-container>
    <v-divider class="my-3" />

    <v-container>
      <NvbbSummaryDrinkPhytoMylkDetail :date="shippingDate" v-model="data.mylk" :loading="loading">
        <span slot="header"
          >สรุปยอดผลิต ของวันที่ {{ produceDate | dateFormat('DD/MM/YYYY') }}</span
        >
      </NvbbSummaryDrinkPhytoMylkDetail>

      <NvbbSummaryDrinkPhytoMylkDetail :date="shippingDate" v-model="data.mylk" :loading="loading">
        <span slot="header"
          >สรุปยอดจัดส่ง ของวันที่ {{ shippingDate | dateFormat('DD/MM/YYYY') }}</span
        >
      </NvbbSummaryDrinkPhytoMylkDetail>
    </v-container>

    <v-divider class="my-3" />
    <v-container>
      <NvbbSummaryDrinkPhytoShotDetail :date="shippingDate" v-model="data.shot" :loading="loading">
        <span slot="header"
          >สรุปยอดผลิต ของวันที่ {{ produceDate | dateFormat('DD/MM/YYYY') }}</span
        >
      </NvbbSummaryDrinkPhytoShotDetail>

      <NvbbSummaryDrinkPhytoShotDetail :date="shippingDate" v-model="data.shot" :loading="loading">
        <span slot="header"
          >สรุปยอดจัดส่ง ของวันที่ {{ shippingDate | dateFormat('DD/MM/YYYY') }}</span
        >
      </NvbbSummaryDrinkPhytoShotDetail>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import NvbbSummaryDrinkDetail from './NvbbSummaryDrinkDetail'
import NvbbSummaryDrinkPhytoSmoozDetail from './NvbbSummaryDrinkPhytoSmoozDetail'
import NvbbSummaryDrinkPhytoMylkDetail from './NvbbSummaryDrinkPhytoMylkDetail'
import NvbbSummaryDrinkPhytoShotDetail from './NvbbSummaryDrinkPhytoShotDetail'
import api from '@/api'
import XLSX from 'xlsx'
export default {
  data() {
    return {
      date: moment().format('YYYY-MM-DD'),
      data: {
        all: {},
        smooz: [],
        mylk: [],
        shot: []
      },
      datemodal: false,
      loading: true,
      loadingExport: false
    }
  },
  components: {
    NvbbSummaryDrinkDetail,
    NvbbSummaryDrinkPhytoSmoozDetail,
    NvbbSummaryDrinkPhytoMylkDetail,
    NvbbSummaryDrinkPhytoShotDetail
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    produceDate() {
      try {
        return moment(this.date).format('YYYY-MM-DD')
      } catch (error) {
        return false
      }
    },
    shippingDate() {
      try {
        return moment(this.date).add(1, 'days').format('YYYY-MM-DD')
      } catch (error) {
        return false
      }
    }
  },
  async mounted() {
    await this.changeDate()
  },
  methods: {
    exportAll() {
      this.loadingExport = true
      let smooz = []
      let mylk = []
      let shot = []

      let smooz_total = {
        small: 0,
        big: 0
      }

      let mylk_total = {
        small: 0,
        big: 0
      }

      let shot_total = {
        small: 0,
        big: 0
      }

      smooz = this.data.smooz.map((el, index) => {
        return [index + 1, el.name, el.small, '', el.big || 0, '', el.small + (el.big || 0)]
      })

      smooz_total = this.data.smooz.reduce(
        (prev, curr) => {
          if (curr.small) {
            prev.small += curr.small
          }
          if (curr.big) {
            prev.big += curr.big
          }
          return prev
        },
        {
          small: 0,
          big: 0
        }
      )

      mylk = this.data.mylk.map((el, index) => {
        return [index + 1, el.name, el.small, '', el.big || 0, '', el.small + (el.big || 0)]
      })

      mylk_total = this.data.mylk.reduce(
        (prev, curr) => {
          if (curr.small) {
            prev.small += curr.small
          }
          if (curr.big) {
            prev.big += curr.big
          }
          return prev
        },
        {
          small: 0,
          big: 0
        }
      )

      shot = this.data.shot.map((el, index) => {
        return [index + 1, el.name, el.small, '', el.big || 0, '', el.small + (el.big || 0)]
      })

      shot_total = this.data.shot.reduce(
        (prev, curr) => {
          if (curr.small) {
            prev.small += curr.small
          }
          if (curr.big) {
            prev.big += curr.big
          }
          return prev
        },
        {
          small: 0,
          big: 0
        }
      )

      let data = [
        [
          'รอบผลิต',
          moment(this.date).format('ddd ที่ DD/MM/YYYY'),
          'ยอดผลิตรวม',
          smooz_total.small +
            smooz_total.big +
            mylk_total.small +
            mylk_total.big +
            shot_total.small +
            shot_total.big
        ],
        ['รอบจัดส่ง', moment(this.date).add(1, 'days').format('ddd ที่ DD/MM/YYYY')],

        [],
        ['PhytoSmooz ผักปั่นไฟเบอร์สูง'],
        ['', 'สูตร', 'ขวดเล็ก', '', 'ขวดใหญ่', '', 'รวม / สูตร'],
        ['', '', '180 ml.', 'หมายเหตุ', '250 ml.', 'หมายเหตุ', ''],
        ...smooz,
        [
          '',
          'รวม',
          smooz_total.small,
          '',
          smooz_total.big,
          '',
          smooz_total.small + smooz_total.big
        ],

        [],
        ['PhytoMylk นมพืช'],
        ['', 'สูตร', 'ขวดเล็ก', '', 'ขวดใหญ่', '', 'รวม / สูตร'],
        ['', '', '180 ml.', 'หมายเหตุ', '250 ml.', 'หมายเหตุ', ''],
        ...mylk,
        ['', 'รวม', mylk_total.small, '', mylk_total.big, '', mylk_total.small + mylk_total.big],

        [],
        ['PhytoSHOT ชอทสกัด'],
        ['', 'สูตร', 'ขวดเล็ก', '', '-', '', 'รวม / สูตร'],
        ['', '', '50 ml.', 'หมายเหตุ', '-', 'หมายเหตุ', ''],
        ...shot,
        ['', 'รวม', shot_total.small, '', shot_total.big, '', shot_total.small + shot_total.big]
      ]

      // const dataWS = XLSX.utils.aoa_to_sheet(data)

      // let sheet = {
      //   Sheet1: {
      //     '!ref': 'A1:G1000',
      //     A1: { t: 's', v: 'รอบผลิต' },
      //     A2: { t: 's', v: 'รอบจัดส่ง' },
      //     C1: { t: 's', v: 'วันศุกร์ ที่ 17/9/64' },
      //     C2: { t: 's', v: 'วันศุกร์ ที่ 17/9/64' },
      //     F1: { t: 's', v: 'ยอดผลิตรวม' },
      //     G1: { t: 'n', v: 112 },
      //     A4: { t: 's', v: 'PhytoSmooz ผักปั่นไฟเบอร์สูง' },
      //     A5: { t: 's', v: 'สูตร ผักปั่น' },

      //     '!merges': [
      //       { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } } /* A1:B1 */,
      //       { s: { r: 1, c: 0 }, e: { r: 1, c: 1 } } /* A2:B2 */,
      //       { s: { r: 0, c: 2 }, e: { r: 0, c: 3 } } /* D1:E1 */,
      //       { s: { r: 1, c: 2 }, e: { r: 1, c: 3 } } /* D2:E2 */,
      //       { s: { r: 0, c: 4 }, e: { r: 1, c: 5 } } /* F1:G2 */,
      //       { s: { r: 0, c: 6 }, e: { r: 1, c: 6 } } /* H1:H2 */
      //     ]
      //   }
      // }
      const wb = XLSX.utils.book_new()
      let dataWB = XLSX.utils.aoa_to_sheet(data)
      XLSX.utils.book_append_sheet(wb, dataWB)
      XLSX.writeFile(wb, `summary-drink-all-${this.date}.xlsx`)
      // XLSX.writeFile(
      //   {
      //     SheetNames: ['Sheet1'],
      //     Sheets: wb
      //   },
      //   'test.xlsx'
      // )
      this.loadingExport = false
    },
    async changeDate() {
      this.loading = true
      try {
        var allPromise = this.get_nvbb_product_amount_by_date('all')
        var smoozPromise = this.get_nvbb_product_amount_by_date('phytosmooz')
        var mylkPromise = this.get_nvbb_product_amount_by_date('phytomylk')
        var shotPromise = this.get_nvbb_product_amount_by_date('phytoshot')
        let response = await Promise.all([allPromise, smoozPromise, mylkPromise, shotPromise])
        if (response[0].data) {
          this.$set(this.data, 'all', response[0].data)
        }
        if (response[1].data) {
          let sorted_smooz = response[1].data.sort((a, b) => {
            return a.name.localeCompare(b.name)
          })
          this.$set(this.data, 'smooz', sorted_smooz)
        }
        if (response[2].data) {
          let sorted_mylk = response[2].data.sort((a, b) => {
            return a.name.localeCompare(b.name)
          })
          this.$set(this.data, 'mylk', sorted_mylk)
        }
        if (response[3].data) {
          let sorted_shot = response[3].data.sort((a, b) => {
            return a.name.localeCompare(b.name)
          })
          this.$set(this.data, 'shot', sorted_shot)
        }
        // this.data = response.data
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    },
    get_nvbb_product_amount_by_date(type = 'all') {
      var data = {
        pageid: this.selectedBot.pageid,
        tab: type,
        date: this.shippingDate
      }
      return new Promise((resolve, reject) => {
        api.get_nvbb_product_amount_by_date(data, (error, response) => {
          if (error) {
            reject(error)
          }

          resolve(response)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/NvbbSummaryDrink.vue